import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Fade from "react-reveal/Fade";

import "./style/style.scss";

import Home from "./pages/Home";
import Nav from "./blocks/Nav";
import Footer from "./blocks/Footer";

export default class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Nav />

          <Main />

          <Footer />
        </div>
      </Router>
    );
  }
}

const Main = props => (
  <main className="Main">
    <Switch>
      <Route
        exact
        path="/"
        render={props => (
          <Fade>
            <Home {...props} />
          </Fade>
        )}
      />
    </Switch>
  </main>
);
